import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonRadioDirective } from 'ngx-bootstrap/buttons';

@Component({
    selector: 'app-onboarding-toggle',
    templateUrl: './onboarding-toggle.component.html',
    styleUrls: ['./onboarding-toggle.component.scss'],
    standalone: true,
    imports: [FormsModule, ButtonRadioDirective]
})
export class OnboardingToggleComponent implements OnInit {
  @Input() btnLabel: string;
  @Input() btnName:  string;
  @Input() btnModel: string;
  @Input() helperText: string;

  @Output() btnModelChange: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  emitChangeEvent(event: string) {
    this.btnModelChange.emit(event);
  }

  formatBtnID(label: string, onOrOff: string): string {
    label = label.toLowerCase().replace(/\s/ig, '-');
    return `${label}-${onOrOff}`;
  }

}
